import { useWeb3React } from '@web3-react/core'
import { Boon } from 'web/lib/boon'
import useBloodToken from './useBloodToken'
import { useSWRConfig } from 'swr'
import { CacheKey } from 'web/lib/cache-keys'
import usePolygonForwarder from './usePolygonForwarder'
import useBloodBalance from './useBloodBalance'
import { useContext } from 'react'
import { StoreContext } from 'web/lib/store'

export default function useBloodShop() {
  const { mutate } = useSWRConfig()
  const { account } = useWeb3React()

  const { updateBloodBalance } = useBloodToken()
  const { polygonForwarderSubmit } = usePolygonForwarder()
  const bloodBalance = useBloodBalance()

  const handleBuyGawd = () => {
    polygonForwarderSubmit('BloodShop', 'buyGawd').then((receipt) => {
      updateBloodBalance(bloodBalance)
    })
  }

  const {
    gawdtchis: [gawdtchis]
  } = useContext(StoreContext)

  const reloadGawchis = () => {
    gawdtchis.gawds.forEach(gawd => {
      mutate(CacheKey.gawchiStats(gawd.gawdId()))
    });
  }

  const handleBuyBoon = async (boon: Boon): Promise<void> => {
    console.log("handleBuyBoon", boon);
    return polygonForwarderSubmit('BloodShop', 'buyBoon', [boon.id]).then((receipt) => {
      updateBloodBalance(bloodBalance - boon.price)
      mutate(CacheKey.myBoons(account))
    })
  }

  const handleActivateBoon = async (boon: Boon): Promise<void> => {
    return polygonForwarderSubmit('BloodShop', 'activateBoon', [boon.id]).then((receipt) => {
      mutate(CacheKey.myBoons(account))
      reloadGawchis()
    })
  }

  return {
    handleBuyGawd,
    handleBuyBoon,
    handleActivateBoon,
  }
}